/**
 * Profile item within a section. Value is display-only type; editable flag comes from API.
 */
export interface ClientProfileItem {
  /** Display label (e.g. "First name", "Department") */
  label: string;
  /** Current value; null/empty when not set */
  value: string | number | null;
  /** When true, UI should render an editable control (e.g. input); otherwise read-only. */
  editable: boolean;
  /** Optional key for form/API when saving (e.g. "firstName", "department") */
  key?: string;
}

/**
 * Section of profile data. API sends an array of sections; UI iterates and renders each.
 */
export interface ClientProfileSection {
  /** Optional id for stable keys and future API targeting */
  id?: string;
  /** Section heading (e.g. "Personal", "Employment") */
  title: string;
  /** Items in this section; order and editability come from API */
  items: ClientProfileItem[];
}

/**
 * Payload of the client profile API response. API controls what is displayed by sending only these sections.
 */
export interface ClientProfilePayload {
  sections: ClientProfileSection[];
}

/**
 * Response shape matching API style: result (status/code/message) + payload.
 * Use with GenericResponseResult so full type is ClientProfileResponse & GenericResponseResult.
 */
export interface ClientProfileResponse {
  payload: ClientProfilePayload;
}

/**
 * Payload for save section API response. API may echo saved fields or return updated section.
 */
export interface ClientProfileSaveSectionPayload {
  sectionId: string;
  /** Keys that were saved (e.g. field keys). */
  savedKeys?: string[];
}

/**
 * Response shape for PATCH / save profile section. Use with GenericResponseResult.
 */
export interface ClientProfileSaveSectionResponse {
  payload: ClientProfileSaveSectionPayload;
}
